export default __webpack_public_path__ + "static/media/36I-102747_-17353_0.bb591884.jpg";